const onboardingApi = (api) => ({
  listOnboardingFiles: () => api.get("/InvoiceProcessing/ListOnboardingFiles"),
  uploadOnboardingFile: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/InvoiceProcessing/UploadOnboardingFile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteOnboardingFile: (fileName) =>
    api.delete(
      `/InvoiceProcessing/DeleteOnboardingFile/${encodeURIComponent(fileName)}`
    ),
  downloadOnboardingFile: (fileName) =>
    api.get(
      `/InvoiceProcessing/DownloadInvoice?fileName=${encodeURIComponent(
        fileName
      )}`,
      {
        responseType: "blob",
      }
    ),
  processOnboardingFile: (file) => {
    const formData = new FormData();
    formData.append("pdfFile", file);
    return api.post("/InvoiceProcessing/ProcessInvoice", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
});

export default onboardingApi;
